import * as firebase from 'firebase'
import 'firebase/firestore'
import { CreateContactParams } from '../actions/contacts'

firebase.initializeApp(JSON.parse(`${process.env.REACT_APP_FIREBASE_APP_CONFIG}`))
const db = firebase.firestore()

export const createContact = async(params: CreateContactParams) => {
	const contactRef = db.collection('contacts')
	await contactRef.add(params).then()
}


// WEBPACK FOOTER //
// ./src/firebase/index.ts